import { sha256 } from "@noble/hashes/sha2.js";
import { base58, createBase58check } from "@scure/base";
import { address as btcAddress, networks } from "bitcoinjs-lib";
import { getAddress, isAddress } from "viem";
const base58check = createBase58check(sha256);
/**
 * One canonical spelling per address, so the same address can't be whitelisted twice in
 * different cases: EVM → checksummed, Bitcoin bech32 (bc1…/tb1…) → lower-case. Legacy Bitcoin
 * (1…/3…/m…/n…/2…), Tron and Solana addresses are case-sensitive and stay unchanged.
 * Call only on addresses that passed isValidAddress.
 */
export function normaliseAddress(family, address) {
    const trimmed = address.trim();
    if (family === "EVM")
        return getAddress(trimmed.toLowerCase());
    if (family === "BITCOIN" && /^(bc1|tb1|bcrt1)/i.test(trimmed))
        return trimmed.toLowerCase();
    return trimmed;
}
export function isValidAddress(family, address, mode) {
    try {
        switch (family) {
            case "EVM":
                // Accept all-lowercase or correctly checksummed; reject wrong mixed case.
                return isAddress(address, { strict: true });
            case "TRON": {
                const bytes = base58check.decode(address);
                return bytes.length === 21 && bytes[0] === 0x41;
            }
            case "BITCOIN": {
                const network = mode === "mainnet" ? networks.bitcoin : networks.testnet;
                btcAddress.toOutputScript(address, network);
                return true;
            }
            case "SOLANA":
                return base58.decode(address).length === 32;
        }
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=address-validation.js.map